import { render, staticRenderFns } from "./ImList.vue?vue&type=template&id=480f7324&"
import script from "./ImList.vue?vue&type=script&lang=js&"
export * from "./ImList.vue?vue&type=script&lang=js&"
import style0 from "./ImList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports